import React from 'react';
import { I18n } from 'react-redux-i18n';
import {
  formatPercent,
  formatTextFloat,
  formatValueBillion,
  formatPrice,
  formatValue,
} from '../../../helpers/Text';
import Const from '../Const';

class ScreenerItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowScreenerDetail: false,
      isShowConfirmEdit: false,
      isShowConfirmDelete: false,
    };
    this.inputEditRef = React.createRef();
  }

  showHideScreenerDetail(e, isShowScreenerDetail) {
    this.setState({ isShowScreenerDetail: !isShowScreenerDetail });
  }

  showConfirmDelete(isShowConfirmDelete) {
    this.setState({ isShowConfirmDelete: !isShowConfirmDelete });
  }

  getFormatParamRange = (param, type) => {
    if (type === Const.unitType.BillionVND.key) {
      return formatTextFloat(formatValueBillion(param));
    }
    if (type === Const.unitType.MillionVND.key) {
      return formatTextFloat(formatValue(param));
    }
    if (
      type === Const.unitType.ThousandVND.key ||
      type === Const.unitType.ThousandUnit.key
    ) {
      return formatTextFloat(formatPrice(param));
    }
    if (type === Const.unitType.Percentage.key) {
      return formatPercent(param);
    }
    if (type === Const.unitType.Unit.key) {
      return formatTextFloat(param);
    }
    return formatTextFloat(param, 0);
  };

  handleDelete(id) {
    const { deleteAction, showHide } = this.props;
    deleteAction(id);
    showHide(false);
    this.resetState();
  }

  showActionEdit() {
    this.resetState();
    this.setState({ isShowConfirmEdit: true });
  }

  showActionDelete() {
    this.resetState();
    this.setState({ isShowConfirmDelete: true });
  }

  changeInputText = text => {
    this.setState({ inputText: text });
  };

  handleEdit = id => {
    this.resetState();
    const name = this.inputEditRef.current.value.trim();
    this.props.editAction(id, name);
    this.props.showHide(false);
  };

  resetState = () => {
    this.setState({
      isShowScreenerDetail: false,
      isShowConfirmEdit: false,
      isShowConfirmDelete: false,
    });
  };

  cancel = () => {
    this.resetState();
    this.props.showHide(false);
  };

  onChangeScreener = (...params) => {
    const { changeScreener, showHide } = this.props;
    changeScreener(...params);
    showHide(false);
  };

  getOriginalParameter(code, listOriginParam) {
    let parameter = null;
    listOriginParam &&
      Object.keys(listOriginParam).forEach(key => {
        const origin = listOriginParam[key].parameters.find(
          p => p.code === code,
        );
        if (origin) {
          parameter = origin;
        }
      });

    return parameter;
  }

  getParamTitle(code) {
    const { listOriginParam } = this.props;
    let name = '';
    if (listOriginParam) {
      listOriginParam.forEach(item => {
        const param = item.parameters.filter(p => p.code === code).pop();
        if (param) {
          name = param.name;
          return;
        }
      });
      return name;
    }
  }

  render() {
    const { screener, isTopScreener, listOriginParam } = this.props;
    const settings = JSON.parse(screener.settings);
    const parameters = (settings && settings.parameters) || [];

    const {
      isShowScreenerDetail,
      isShowConfirmEdit,
      isShowConfirmDelete,
    } = this.state;

    const detailContent = (
      <>
        {parameters.length > 0 && <hr />}
        {listOriginParam &&
          parameters.forEach((value, index) => {
            const origin = this.getOriginalParameter(
              value.code,
              listOriginParam,
            );
            if (origin) {
              const title =
                this.getFormatParamRange(value.selectedValue[0], origin.unit) +
                Const.unitType[origin.unit].text +
                '-' +
                this.getFormatParamRange(value.selectedValue[1], origin.unit) +
                Const.unitType[origin.unit].text;

              return (
                <div key={index} className="detail-param d-flex">
                  <div
                    className="text-truncate"
                    title={this.getParamTitle(value.code)}
                    style={{ width: '50%' }}
                  >
                    {this.getParamTitle(value.code)}
                  </div>
                  {value.type === Const.paramType.RANGE && (
                    <div
                      className="text-right text-truncate"
                      style={{ width: '50%' }}
                      title={title}
                    >
                      {title}
                    </div>
                  )}
                  {value.type === Const.paramType.VALUE && (
                    <div
                      className="text-right text-truncate"
                      style={{ width: '50%' }}
                    >
                      {value.selectedValue.map((item, index) => {
                        return index === value.selectedValue.length - 1 ? (
                          <span key={index}>{`${item} `}</span>
                        ) : (
                          <span key={index}>{item} - </span>
                        );
                      })}
                    </div>
                  )}
                  {value.type === Const.paramType.BOOLEAN && (
                    <div
                      className="text-right text-truncate"
                      style={{ width: '50%' }}
                      title={this.getFormatParamRange(
                        value.selectedValue[0],
                        origin.unit,
                      )}
                    >
                      {this.getFormatParamRange(
                        value.selectedValue[0],
                        origin.unit,
                      )}
                    </div>
                  )}
                </div>
              );
            }
          })}
        <div style={{ clear: 'both' }} />
      </>
    );

    let content = (
      <div className="d-flex justify-content-between">
        <div
          className="screener-name text-truncate"
          onClick={() =>
            this.onChangeScreener(screener.screenerId, isTopScreener)
          }
          title={screener.name}
        >
          {screener.name}
        </div>
        <div
          className="expand-button"
          onClick={e =>
            this.showHideScreenerDetail(e, this.state.isShowScreenerDetail)
          }
        >
          <i className="expand-status-icon float-right icon-next"> </i>
        </div>
      </div>
    );

    if (isShowConfirmEdit) {
      content = (
        <div className="screener-expand">
          <div className="d-flex">
            <input
              className="text-input"
              autoFocus
              type="text"
              style={{ width: 118 }}
              onChange={e => this.changeInputText(e.target.value)}
              ref={this.inputEditRef}
              defaultValue={screener.name}
            />
            <span className="float-right">
              <span
                className="text-s-color-5 fs-16 mr-5"
                onClick={() => this.handleEdit(screener.screenerId)}
              >
                <i className="icon-correct" />
              </span>
              <span className="text-s-color-3 fs-13 mr-5" onClick={this.cancel}>
                <i className="icon-remove-symbol" />
              </span>
              <span>
                <i
                  style={{ transform: 'rotate(90deg)' }}
                  className="expand-status-icon float-right mt-10 icon-next"
                  onClick={e => this.cancel()}
                />
              </span>
            </span>
          </div>
          {detailContent}
        </div>
      );
    }

    if (isShowConfirmDelete) {
      content = (
        <div className="confirm-delete">
          <div>{I18n.t('stockScreener.screenerMessage.confirmDelete')}</div>
          <div>
            <div className="btn-edit pt-10 pb-5">
              <div
                className="btn active btn-cus-nomal bg-b-color-3 mr-5"
                onClick={() => this.handleDelete(screener.screenerId)}
              >
                {I18n.t('stockScreener.button.DELETE')}
              </div>
              <div
                className="btn btn-cus-nomal btn-cancel-delete ml-5"
                onClick={this.resetState}
              >
                {I18n.t('stockScreener.button.CANCEL')}
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (isShowScreenerDetail) {
      content = (
        <div className="screener-expand">
          <div className="d-flex">
            <div
              className="screener-name text-truncate"
              onClick={() =>
                this.onChangeScreener(screener.screenerId, isTopScreener)
              }
              title={screener.name}
            >
              <span>{screener.name}</span>
            </div>

            {!isTopScreener && (
              <span className="float-right">
                <span
                  className="mr-5"
                  onClick={() =>
                    this.showActionEdit(this.state.isShowConfirmEdit)
                  }
                >
                  <i className="icon-pencil-edit" />
                </span>
                <span
                  className="mr-5"
                  onClick={() => this.showActionDelete(screener.screenerId)}
                >
                  <i className="icon-bin-delete" />
                </span>
              </span>
            )}
            <div
              className="expand-button"
              onClick={e =>
                this.showHideScreenerDetail(e, this.state.isShowScreenerDetail)
              }
            >
              <i
                style={{ transform: 'rotate(90deg)' }}
                className="expand-status-icon float-right pt-5 icon-next"
              />
            </div>
          </div>
          {detailContent}
        </div>
      );
    }
    return (
      <div className="screener-item">
        <div className="screener-item-content">{content}</div>
      </div>
    );
  }
}

export default ScreenerItem;
